import { OrderRejectionReason } from '../../../../../services/exports/Constants';

export default {
  header: 'Bestelling annuleren',
  title: 'Annuleer nooit te lichtvaardig!',
  text: 'Bel bij een klein probleem de klant en los het samen op.',
  reasons: {
    [OrderRejectionReason.ItemUnavailable]: 'Artikelen niet op voorraad',
    [OrderRejectionReason.ClosingSoon]: 'Winkel is gesloten',
    [OrderRejectionReason.StoryBusy]: 'Winkel is te druk',
    [OrderRejectionReason.CustomerMistake]: 'Klant belde om te annuleren',
    [OrderRejectionReason.DriverNotArrived]: 'Chauffeur niet aangekomen',
  },
  buttons: {
    confirm: 'Bevestigen',
  },
};
